import { Injectable } from '@angular/core';
import { STATUS } from '@core/consts';
import { EquipmentMaintenanceMapped, Maintenance } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class EquipmentMaintenanceMapperService {
  public STATUS = STATUS;

  constructor(private translateService: TranslateService) {}

  public toEquipmentMaintenancesMapped(maintenances: Maintenance[]): EquipmentMaintenanceMapped[] {
    const maintenancesMapped: EquipmentMaintenanceMapped[] = [];

    maintenances.forEach((maintenance) => {
      const status = STATUS.find((maintenanceStatus) => maintenanceStatus.name === maintenance.status);

      const maintenanceMapped = {
        id: maintenance.id,
        log: maintenance.logs[0] || null,
        status: maintenance.status,
        icon: status.icon,
        isCreated: true,
        eventDescription: {
          location: this.translateService.instant(
            'EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.LOCATION',
            { locationName: maintenance.location.name }
          ),
          segment: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.SEGMENT', {
            segmentName: maintenance.segment.name
          }),
          maintenanceType: this.translateService.instant(
            'EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.MAINTENANCE_TYPE',
            { maintenanceTypeName: maintenance.maintenanceType.name }
          ),
          company: maintenance.company ? this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.COMPANY', {
            companyName: maintenance.company.name
          }) : this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.EVENT_DESCRIPTION.WITHOUT_COMPANY')
        },
        eventName:
          this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.MAINTENANCE_TITLE', {
            maintenanceNumber: maintenance.number
          }) + ` - <span><b>${this.translateService.instant(status.translation)}</b></span>`,
        colorClass: status.name,
        formattedCreatedAt: moment(maintenance.openedAt).local().format('DD/MM/YYYY'),
        createdAt: moment(maintenance.openedAt).local().format('DD/MM/YYYY HH:mm:ss'),
        showMessage: true
      };

      maintenancesMapped.push(maintenanceMapped);
    });

    return maintenancesMapped;
  }
}
